// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import Vue from 'vue';
import { wrapResponseWithDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import RequestConfig from '@glittr/frontend-core/src/plugins/servicelayer/requestConfig';
import PostSensorLogRequestModel from '../../model/post-sensor-log-request-model';

export default (service: Servicelayer) => ({
  /**  */
  async postSensorLog(request: PostSensorLogRequestModel, config?: RequestConfig) {
    const requestDTO = PostSensorLogRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-post-sensor-log'] ?? 'Sensorlogs';
    const response = await service.post<any>(endpointPath, {
      body: {
        requestData: requestDTO.requestData,
      },
      ...config,
    });
    const result = response?.data?.result ?? response?.data;
    return wrapResponseWithDataRecord(result as number);
  },
});
